"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapFacetQueryToFilterValues = void 0;
/**
 * Maps active sub-filters to filter values.
 *
 * @param facets - The subset of facets that are active.
 * @param data - All available filter values.
 *
 * @returns An array of filter values, each representing a filter category with its label and selected keys.
 */ const isFacetSelected = (facet, selectedFacets, category)=>{
    const foundFacet = selectedFacets.find((selectedFacet)=>selectedFacet.name === category.key);
    if (!foundFacet) {
        return false;
    }
    return foundFacet.keys.includes(facet.value);
};
const mapFacetQueryToFilterValues = (facets, data)=>data.map((category)=>({
            ...category,
            items: category.items.map((item)=>({
                    ...item,
                    selected: facets ? isFacetSelected(item, facets, category) : false
                }))
        }));
exports.mapFacetQueryToFilterValues = mapFacetQueryToFilterValues;
